import * as React from "react"

export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <main className="grid min-h-dvh bg-page text-ink-body lg:grid-cols-[minmax(20rem,.8fr)_1.2fr]">
      <section className="hidden bg-ink-display p-10 text-page lg:flex lg:flex-col lg:justify-between">
        <p className="font-display text-lg font-semibold text-page">Contracting OS</p>
        <div className="max-w-md">
          <p className="text-sm font-medium tracking-wide text-page/65">Built for work that leaves a trail</p>
          <h1 className="mt-4 text-4xl text-page">From site evidence to commercial control.</h1>
          <p className="mt-5 text-base leading-7 text-page/70">Plan scope, record production and keep every approval connected to the work it came from.</p>
        </div>
        <p className="text-xs text-page/50">Private company workspaces · role-aware access</p>
      </section>
      <section className="flex items-center justify-center px-4 py-12 sm:px-8">
        <div className="w-full max-w-md">
          <p className="mb-8 font-display text-base font-semibold text-ink-display lg:hidden">Contracting OS</p>
          <div className="panel p-5 sm:p-7">{children}</div>
        </div>
      </section>
    </main>
  )
}
